import Vue from 'vue'
import VueGoodTablePlugin from 'vue-good-table';

Vue.use(VueGoodTablePlugin);
